import { SvgIconProps, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useMemo } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '48px',
    borderBottom: '2px solid transparent',
    color: theme.palette.darkSlate.main,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    transitionDuration: '240ms'
  },
  rootActive: {
    color: theme.palette.secondary.main,
    borderBottomColor: theme.palette.secondary.main,
  },
  icon: {
    fontSize: '28px',
    color: 'inherit',
  },
  tooltip: {
    margin: '3px 0',
    backgroundColor: theme.palette.grey[800],
    fontSize: '14px',
    lineHeight: '16px',
    paddingTop: '5px',
    paddingBottom: '3px',
  },
}));


export type NavigationLinkProps = {
  title: string;
  icon: React.ComponentType<SvgIconProps>;
  iconActive: React.ComponentType<SvgIconProps>;
  path: string;
  exact?: boolean;
  asAnchor?: boolean;
};


export const NavigationLink: React.FC<NavigationLinkProps> = (props) => {
  const { classes, cx } = useStyles();
  const match = useRouteMatch({
    path: props.path,
    exact: props.exact,
  });

  const rootClassName = cx(classes.root, {
    [classes.rootActive]: !!match,
  });

  const CurrentIcon = match ? props.iconActive : props.icon;

  const [ open, setOpen ] = React.useState(false);

  const link = useMemo(() => {
    if (props.asAnchor) {
      return (
        <a
          href={props.path}
          target="_blank"
          rel="noopener noreferrer"
          className={rootClassName}
        >
          <CurrentIcon className={classes.icon} />
        </a>
      );
    }

    return (
      <Link className={rootClassName} to={props.path}>
        <CurrentIcon className={classes.icon} />
      </Link>
    );
  }, [ CurrentIcon, classes.icon, props.asAnchor, props.path, rootClassName ]);

  return (
    <Tooltip
      open={open}
      onOpen={() => !match && setOpen(true)}
      onClose={() => setOpen(false)}
      title={props.title}
      classes={{
        tooltipPlacementBottom: classes.tooltip
      }}
    >
      {link}
    </Tooltip>
  );
};
